import React from 'react';
import { Table, InputNumber, Button, Upload } from 'antd';
import { Download, Upload as UploadIcon, Save, ReceiptText, Package } from 'lucide-react';
import { SectionCard, StatusTag, EmptyState } from '../../../common';
import { usePriceListEditor } from './priceList.controller';

function PriceList({ handleConvert, products, storeType, setProducts, priceList, converted, createPriceList }) {
    const { dataSource, updateProduct, download } = usePriceListEditor({ products, storeType, setProducts, priceList, converted });
    const isModerno = storeType?.channel === 'moderno';

    const columns = [
        {
            title: 'Producto',
            dataIndex: 'productName',
            key: 'productName',
            fixed: 'left',
            width: 250,
            render: (text) => <span className="font-medium text-surface-900">{text}</span>
        }
    ];

    if (isModerno) {
        columns.push({
            title: 'Margen Sugerido',
            dataIndex: 'suggestedMargin',
            key: 'suggestedMargin',
            width: 200,
            render: (value, record) => (
                <InputNumber
                    value={value}
                    onChange={(val) => updateProduct(record.productId, 'suggestedMargin', val)}
                    className="w-full tabular-nums"
                    precision={2}
                    min={0}
                    max={100}
                    suffix="%"
                    controls={false}
                    keyboard={true}
                />
            )
        });
    }

    columns.push({
        title: 'Precio Sugerido',
        dataIndex: 'suggestedPrice',
        key: 'suggestedPrice',
        width: 180,
        render: (value, record) => (
            <InputNumber
                value={value}
                onChange={(val) => updateProduct(record.productId, 'suggestedPrice', val)}
                className="w-full tabular-nums"
                precision={2}
                min={0}
                prefix="$"
                controls={false}
                keyboard={true}
            />
        )
    });

    if (isModerno) {
        columns.push({
            title: 'Costo Cliente (Con IVA)',
            dataIndex: 'price',
            key: 'price',
            width: 200,
            render: (value, record) => (
                <InputNumber
                    value={value}
                    onChange={(val) => updateProduct(record.productId, 'price', val)}
                    className="w-full tabular-nums"
                    precision={2}
                    min={0}
                    prefix="$"
                    controls={false}
                    keyboard={true}
                />
            )
        });
    }

    return (
        <SectionCard
            flush
            icon={<ReceiptText />}
            iconTone="brand"
            title={storeType?.label || 'Lista de Precios'}
            description={
                <span className="inline-flex items-center gap-1.5 mt-0.5">
                    Canal: <StatusTag tone={isModerno ? 'info' : 'warning'}>{storeType?.channel?.toUpperCase()}</StatusTag>
                </span>
            }
            extra={
                <>
                    <Upload
                        accept=".xls,.xlsx"
                        showUploadList={false}
                        beforeUpload={(file) => {
                            handleConvert(file);
                            return false;
                        }}>
                        <Button icon={<UploadIcon />}>Importar Excel</Button>
                    </Upload>
                    <Button icon={<Download />} onClick={download}>
                        Descargar Excel
                    </Button>
                </>
            }>
            <Table
                dataSource={dataSource}
                columns={columns}
                pagination={{
                    pageSize: 50,
                    showSizeChanger: true,
                    showTotal: (total) => `Total: ${total} productos`
                }}
                locale={{
                    emptyText: (
                        <EmptyState icon={<Package />} title="Sin productos" description="La segmentación de esta lista no tiene productos." />
                    )
                }}
                scroll={{ x: 800 }}
                size="middle"
            />

            <div className="flex justify-end gap-2 px-5 py-4 border-t border-surface-100">
                <Button type="primary" icon={<Save />} onClick={() => createPriceList()}>
                    Guardar Lista de Precios
                </Button>
            </div>
        </SectionCard>
    );
}

export default PriceList;
